module.exports = __webpack_public_path__ + "static/media/default-user.907ce9a7.svg";